export default __webpack_public_path__ + "static/media/closeWalletModalBtnDark.7623ff0a.svg";